import React from 'react';
import { CheckIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
type Volume = {
  number: string;
  title: string;
  subtitle: string;
  body: string;
  promise: string;
  flag?: string;
};
const volumes: Volume[] = [{
  number: 'Tomo 1',
  title: 'El Salto de Valor',
  subtitle: 'De «la que ayuda con las bodas» a referente indiscutible',
  body: 'Reprograma tu marca para atraer a la novia de alto presupuesto y repeler al cazador de ofertas. Vas a construir un posicionamiento de autoridad que hace que el precio sea la última preocupación de tu clienta — y que hace que el «precio de amiga» deje de ser una pregunta que te hacen.',
  promise: 'Dejas de competir por barata y empiezas a competir por deseada.'
}, {
  number: 'Tomo 2',
  title: 'El Embudo de WhatsApp Gold',
  subtitle: 'La ciencia de cerrar contratos en la palma de tu mano',
  body: 'En el mundo hispano el contrato no se gana por email: se gana por WhatsApp. Aquí está la arquitectura exacta. Qué contestar al «Hola, ¿precio para boda?». Cómo detectar presupuesto sin preguntarlo de frente. Cuándo mandar audio y cuándo jamás. Los tiempos de respuesta que construyen deseo en vez de desesperación. Y la secuencia completa que lleva de la consulta fría a la reunión de cierre.',
  promise: 'Se acabó contestar a las 11 de la noche por miedo a perder la venta.',
  flag: 'El corazón del sistema'
}, {
  number: 'Tomo 3',
  title: 'Protocolo Anti-Ghosting',
  subtitle: 'Cómo recuperar el control cuando te dejan en visto',
  body: 'El silencio después del presupuesto tiene solución y no es «esperar a ver». Secuencias de seguimiento psicológico que reactivan el interés y te dan una respuesta clara —sí o no— en días, no en semanas de revisar el celular preguntándote qué hiciste mal.',
  promise: 'Recuperas el control de la conversación. Y de tu cabeza.'
}, {
  number: 'Tomo 4',
  title: 'Ingeniería de la Recomendación',
  subtitle: 'Que la boda de tu prima deje de ser un favor y empiece a ser tu mejor vendedora',
  body: 'Un sistema paso a paso para que cada boda te traiga tres más. Cómo orquestar la experiencia de la pareja, de las dos familias, de los padrinos y de los invitados para que la recomendación deje de ser un accidente y pase a ser una consecuencia inevitable de tu forma de trabajar.',
  promise: 'En una boda latina no tienes un cliente: tienes 200 testigos. Úsalos.'
}, {
  number: 'Tomo 5',
  title: 'Finanzas de Guerra para Creativos',
  subtitle: 'Blindaje de rentabilidad',
  body: 'Cómo dejar de trabajar gratis sin darte cuenta. Calculas tus costos reales (incluida tu hora, que hoy vale cero en tu cuenta), proyectas tu flujo de caja en mercados que se mueven, defines anticipos que te protegen y subes tus tarifas con argumentos, no con culpa.',
  promise: 'Cobras lo que vales sin sentir que estás haciendo algo malo.'
}, {
  number: 'Tomo 6',
  title: 'Tráfico Directo Premium',
  subtitle: 'Tu libertad frente a Bodas.net y Matrimonio.com',
  body: 'El manual estratégico para captar novias de alto nivel en Meta Ads. Cómo segmentar por poder adquisitivo real, qué mostrar en el anuncio y cómo llevar ese lead directo a tu WhatsApp.',
  promise: 'Clientas propias, sin pagar una cuota mensual para aparecer en una lista al lado de otras cincuenta planners iguales a ti.'
}];
const includes = ['Frameworks paso a paso', 'Guiones palabra por palabra', 'Checklists y plantillas imprimibles', 'Materiales listos para enviar a tus clientas', 'Sistemas universales — cualquier país, cualquier moneda, cualquier presupuesto'];
export function Tomes() {
  return <section className="w-full bg-ivory py-16 sm:py-24" data-id="element-245" data-mp="rnnmoh8l727w">
      <div className="mx-auto max-w-6xl px-5" data-id="element-246" data-mp="rp8isbajut7v">
        <h2 className="text-center font-serif text-3xl sm:text-5xl text-ink" data-id="element-247" data-mp="3r9ubpi5qtwlk">
          Seis tomos. El negocio completo. Cero improvisación.
        </h2>
        <div className="rule-gold mx-auto mt-8 w-32" aria-hidden="true" data-id="element-248" data-mp="3va4igx1d0r1h" />

        <ul className="mt-14 grid gap-6 lg:grid-cols-3" data-id="element-249" data-mp="3c85dan37e9fz">
          {volumes.map(volume => <li key={volume.number} className={`flex flex-col border bg-white p-7 transition-shadow duration-300 hover:shadow-card ${volume.flag ? 'border-gold' : 'border-gold-soft/70'}`} data-id="element-250" data-mp="37ac5jpm957dl">
              <div className="flex items-center justify-between gap-3" data-id="element-251" data-mp="3uxkechiw2ykd">
                <span className="text-[10px] uppercase tracking-[0.24em] text-gold-dark" data-id="element-252" data-mp="3pzagu09ozlvl">
                  {volume.number}
                </span>
                {volume.flag && <span className="inline-flex items-center gap-1.5 bg-gold-tint px-2.5 py-1 text-[10px] uppercase tracking-[0.14em] text-gold-dark" data-id="element-253" data-mp="8osw7yliuyrb">
                    <StarIcon className="h-3 w-3 fill-gold text-gold" aria-hidden="true" data-id="element-254" data-mp="2ajjqmvb21lde" />
                    {volume.flag}
                  </span>}
              </div>

              <h3 className="mt-4 font-serif text-2xl leading-snug text-ink" data-id="element-255" data-mp="l14pf8906sjd">
                {volume.title}
              </h3>
              <p className="mt-2 text-xs uppercase tracking-[0.1em] text-ink-muted" data-id="element-256" data-mp="pz6b80xtd5yj">
                {volume.subtitle}
              </p>
              <p className="mt-5 flex-1 text-[15px] leading-relaxed text-ink-soft" data-id="element-257" data-mp="b9qt19ccm8ug">
                {volume.body}
              </p>
              <p className="mt-6 border-t border-gold-soft/70 pt-5 font-serif text-base italic text-gold-dark" data-id="element-258" data-mp="2anbwawqs3il">
                → {volume.promise}
              </p>
            </li>)}
        </ul>

        <div className="mt-12 border border-gold-soft bg-gold-tint px-6 py-8" data-id="element-259" data-mp="3oiwpzb17gkt6">
          <p className="text-center text-[11px] uppercase tracking-[0.24em] text-ink-soft" data-id="element-260" data-mp="3tgy9fx2jmm56">
            Dentro de cada tomo
          </p>
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-7 gap-y-3" data-id="element-261" data-mp="1ms1oq3o8btf2">
            {includes.map(item => <li key={item} className="inline-flex items-center gap-2 text-sm text-ink" data-id="element-262" data-mp="1rnh1esai3j9w">
                <CheckIcon className="h-4 w-4 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-263" data-mp="1q6l28822udj7" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="mt-12 flex justify-center" data-id="element-264" data-mp="1gb9ptwe55iem">
          <CtaButton data-id="element-265" data-mp="1bbn8pbv6zi0j">Quiero instalar el sistema completo</CtaButton>
        </div>
      </div>
    </section>;
}